export type TopicCategory = '影视' | '综艺' | '音乐' | '网络' | '品牌' | '科技';

export interface TopicTimelineItem {
  time: string;
  title: string;
  desc: string;
  source: string;
  tag: string;
}

export interface TopicReport {
  media: string;
  title: string;
  angle: string;
  time: string;
}

export interface Topic {
  slug: string;
  title: string;
  category: TopicCategory;
  cover: string;
  summary: string;
  heat: number;
  followers: string;
  updateCount: number;
  startedAt: string;
  status: '持续发酵' | '已平息' | '出现反转';
  timeline: TopicTimelineItem[];
  reports: TopicReport[];
}

export const topicList: Topic[] = [
  {
    slug: 'film-festival-red-carpet',
    title: '电影节红毯造型争议：从图集释出到造型团队回应',
    category: '影视',
    cover:
      'https://readdy.ai/api/search-image?query=elegant%20abstract%20red%20carpet%20scene%20with%20warm%20amber%20stage%20lights%20and%20soft%20bokeh%2C%20editorial%20magazine%20cover%20style%20illustration%2C%20cream%20and%20rose%20tones%2C%20no%20text%2C%20harmonious%20composition&width=1200&height=800&seq=topic-cover-film-01&orientation=landscape',
    summary:
      '一组官方红毯图集释出后，礼服配色与妆发风格成为讨论焦点。随着对比图在社交平台流转，造型团队发布设计思路说明，事件热度持续两天。',
    heat: 9860,
    followers: '3.2万',
    updateCount: 6,
    startedAt: '09-08 14:20',
    status: '持续发酵',
    timeline: [
      {
        time: '09-08 14:20',
        title: '官方红毯图集释出',
        desc: '主办方发布开幕红毯完整图集，其中两套礼服的配色方案在评论区被反复提及。',
        source: '官方图集',
        tag: '事件起点',
      },
      {
        time: '09-08 17:05',
        title: '对比图在社交平台流转',
        desc: '网友把同场其他造型与争议造型并排对比，转发量在两小时内快速上升，话题进入榜单。',
        source: '社交平台',
        tag: '扩散',
      },
      {
        time: '09-08 20:44',
        title: '造型团队发布设计说明',
        desc: '造型团队公开设计手稿与配色依据，解释了礼服选型的思路，并称尊重不同审美意见。',
        source: '造型团队',
        tag: '回应',
      },
      {
        time: '09-09 09:24',
        title: '媒体集中跟进报道',
        desc: '多家文娱媒体从红毯文化、造型工业链等角度切入，报道口径出现明显差异。',
        source: '多家媒体',
        tag: '媒体报道',
      },
      {
        time: '09-09 15:40',
        title: '设计师本人补充说明',
        desc: '设计师在个人账号补充了面料选择的原因，并透露工期安排对最终方案的影响。',
        source: '设计师账号',
        tag: '补充',
      },
      {
        time: '09-10 09:24',
        title: '热度回落但仍有余波',
        desc: '讨论量较峰值下降约四成，但相关话题仍在文娱榜单中保持中位，事件进入长尾阶段。',
        source: '站内统计',
        tag: '降温',
      },
    ],
    reports: [
      {
        media: '星线文娱',
        title: '红毯造型讨论背后，是审美分歧还是传播放大',
        angle: '从传播链路角度分析讨论为何集中爆发',
        time: '09-09 09:24',
      },
      {
        media: '剧集观察室',
        title: '造型团队发声之后，争议为何没有平息',
        angle: '关注回应时机与沟通方式的影响',
        time: '09-09 11:10',
      },
      {
        media: '城市文化周刊',
        title: '红毯经济：一次造型能带动多少讨论',
        angle: '以行业视角拆解红毯造型的商业链路',
        time: '09-10 08:30',
      },
    ],
  },
  {
    slug: 'drama-premiere-review',
    title: '新剧开播口碑分化：节奏处理成最大分歧点',
    category: '影视',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20cinematic%20scene%20with%20warm%20amber%20projector%20light%20and%20soft%20film%20grain%20texture%2C%20editorial%20illustration%20style%2C%20cream%20and%20terracotta%20palette%2C%20no%20text&width=1200&height=800&seq=topic-cover-drama-02&orientation=landscape',
    summary:
      '剧集开播首周评分区间稳定在两极，前四集节奏成为争论核心。剧方在第二版预告中调整了镜头重心，被视为对讨论的间接回应。',
    heat: 8420,
    followers: '2.7万',
    updateCount: 5,
    startedAt: '09-06 20:00',
    status: '持续发酵',
    timeline: [
      {
        time: '09-06 20:00',
        title: '剧集正式开播',
        desc: '首日更新两集，剧集在开播两小时内进入平台热度榜前列。',
        source: '播出平台',
        tag: '事件起点',
      },
      {
        time: '09-08 10:08',
        title: '第二版预告发布',
        desc: '新预告把镜头更多给到配角群像，剧方表示剪辑呈现不影响正片结构。',
        source: '剧方',
        tag: '回应',
      },
      {
        time: '09-09 09:02',
        title: '首周评分出炉',
        desc: '评分区间趋于稳定但两极分化明显，节奏与人物铺垫成为两大讨论方向。',
        source: '评分平台',
        tag: '数据',
      },
      {
        time: '09-09 17:28',
        title: '片场路透流出',
        desc: '一组非官方路透图流传，制片方呼吁围观者与拍摄区域保持距离。',
        source: '制片方',
        tag: '延伸',
      },
      {
        time: '09-10 09:02',
        title: '剧方回应节奏争议',
        desc: '剧方在采访中表示后续叙事节奏会加快，并解释了前段铺垫的创作考虑。',
        source: '媒体采访',
        tag: '回应',
      },
    ],
    reports: [
      {
        media: '剧集观察室',
        title: '前四集到底慢在哪：一次叙事节奏的拆解',
        angle: '逐集分析铺垫密度与信息释放节奏',
        time: '09-09 09:02',
      },
      {
        media: '影视工业评论',
        title: '评分两极分化，说明观众口味变了吗',
        angle: '从观众结构变化讨论评分分化现象',
        time: '09-10 07:40',
      },
      {
        media: '星线文娱',
        title: '剧方回应节奏争议，主创透露后续走向',
        angle: '采访主创还原创作思路',
        time: '09-10 10:15',
      },
    ],
  },
  {
    slug: 'variety-show-rule-change',
    title: '综艺赛制调整引讨论：投票权重改动是否公平',
    category: '综艺',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20stage%20spotlight%20scene%20with%20warm%20amber%20and%20teal%20accents%2C%20minimal%20editorial%20illustration%2C%20cream%20background%2C%20no%20text%2C%20clean%20geometric%20shapes&width=1200&height=800&seq=topic-cover-variety-03&orientation=landscape',
    summary:
      '本季节目把投票权重调整为线上线下各占一半，首期播出后，讨论集中在规则变化对选手类型的实际影响上，节目组随后补充了细则说明。',
    heat: 7215,
    followers: '1.9万',
    updateCount: 4,
    startedAt: '09-07 21:30',
    status: '持续发酵',
    timeline: [
      {
        time: '09-07 21:30',
        title: '首期节目播出',
        desc: '新赛制首次亮相，投票权重调整成为弹幕与评论区的高频关键词。',
        source: '播出平台',
        tag: '事件起点',
      },
      {
        time: '09-08 12:00',
        title: '节目组补充细则',
        desc: '节目组发布规则细则说明，强调权重设计是为了平衡现场与线上观众的参与度。',
        source: '节目组',
        tag: '回应',
      },
      {
        time: '09-09 11:37',
        title: '常驻嘉宾阵容调整',
        desc: '两位常驻嘉宾因档期退出，新嘉宾补位，节目组称剧情走向不受明显影响。',
        source: '节目组',
        tag: '延伸',
      },
      {
        time: '09-10 08:47',
        title: '讨论延伸至赛制公平性',
        desc: '有观众整理历届投票数据做对比，讨论从单一规则扩展到整体赛制设计。',
        source: '社交平台',
        tag: '扩散',
      },
    ],
    reports: [
      {
        media: '综艺速递',
        title: '投票权重改了，观众为什么反应这么大',
        angle: '梳理规则变化与观众预期的落差',
        time: '09-08 15:20',
      },
      {
        media: '媒介观察',
        title: '从赛制调整看综艺的参与感设计',
        angle: '以参与感为线索分析赛制演进',
        time: '09-10 09:00',
      },
      {
        media: '星线文娱',
        title: '节目组回应赛制争议，强调规则透明',
        angle: '记录节目组的官方口径',
        time: '09-10 11:30',
      },
    ],
  },
  {
    slug: 'music-festival-lineup',
    title: '音乐节阵容官宣：开票一分钟多档票档售罄',
    category: '音乐',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20outdoor%20music%20festival%20stage%20at%20dusk%20with%20warm%20amber%20lights%20and%20crowd%20silhouettes%2C%20editorial%20illustration%2C%20cream%20and%20terracotta%20tones%2C%20no%20text&width=1200&height=800&seq=topic-cover-music-04&orientation=landscape',
    summary:
      '阵容覆盖摇滚与独立流行两个方向，开票后多档票档快速售罄。主办方随后公布交通接驳方案与扩容措施，讨论转向现场体验。',
    heat: 6980,
    followers: '2.4万',
    updateCount: 4,
    startedAt: '09-05 19:00',
    status: '持续发酵',
    timeline: [
      {
        time: '09-05 19:00',
        title: '阵容正式官宣',
        desc: '主办方公布完整阵容，两个舞台共计数十组音乐人，当晚话题进入音乐榜单。',
        source: '主办方',
        tag: '事件起点',
      },
      {
        time: '09-08 12:00',
        title: '门票开售',
        desc: '多档票档在一分钟内售罄，部分观众反映排队页面等待时间偏长。',
        source: '售票平台',
        tag: '扩散',
      },
      {
        time: '09-09 15:52',
        title: '交通接驳方案公布',
        desc: '主办方联合交通部门新增夜间返程专线，接驳线路增至六条。',
        source: '主办方',
        tag: '回应',
      },
      {
        time: '09-10 08:20',
        title: '主办方回应售票压力',
        desc: '主办方称正在扩容售票通道，并提示观众通过官方渠道购票。',
        source: '主办方',
        tag: '回应',
      },
    ],
    reports: [
      {
        media: '现场CUE',
        title: '一分钟售罄背后，音乐节为什么越来越难抢',
        angle: '分析演出市场的供需变化',
        time: '09-09 10:00',
      },
      {
        media: '城市文化周刊',
        title: '接驳六条线路，地方文旅为何加码音乐节',
        angle: '从城市文旅角度观察音乐节价值',
        time: '09-10 08:20',
      },
      {
        media: '媒介观察',
        title: '抢票体验也是产品体验',
        angle: '从售票系统视角讨论服务体验',
        time: '09-10 13:10',
      },
    ],
  },
  {
    slug: 'brand-crossover-launch',
    title: '品牌联名上线：快闪排队画面流出后的补货说明',
    category: '品牌',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20minimal%20retail%20display%20scene%20with%20warm%20amber%20light%20and%20cream%20geometric%20podiums%2C%20editorial%20product%20illustration%2C%20no%20text%2C%20clean%20composition&width=1200&height=800&seq=topic-cover-brand-05&orientation=landscape',
    summary:
      '联名系列覆盖服饰与生活周边十余款，上线当晚部分门店出现排队。品牌方发布限购与补货说明，讨论随后转向二手市场价格波动。',
    heat: 6640,
    followers: '1.5万',
    updateCount: 4,
    startedAt: '09-07 20:00',
    status: '已平息',
    timeline: [
      {
        time: '09-07 20:00',
        title: '联名系列正式上线',
        desc: '系列包含服饰与生活周边十余款，线上渠道与部分门店同步开售。',
        source: '品牌方',
        tag: '事件起点',
      },
      {
        time: '09-09 22:16',
        title: '快闪店排队画面流出',
        desc: '网友拍下部分门店排队情况，画面在社交平台快速传播。',
        source: '社交平台',
        tag: '扩散',
      },
      {
        time: '09-09 14:09',
        title: '二手市场价格波动',
        desc: '热门单品在二手平台出现明显加价，品牌方提醒通过官方渠道购买。',
        source: '二手平台',
        tag: '延伸',
      },
      {
        time: '09-10 10:30',
        title: '品牌方发布补货说明',
        desc: '品牌方表示将分批补货并实行限购，部分门店改为预约入场。',
        source: '品牌方',
        tag: '回应',
      },
    ],
    reports: [
      {
        media: '消费前线',
        title: '联名为什么总能排队：一次营销节奏的复盘',
        angle: '复盘发售节奏与限购策略',
        time: '09-09 23:00',
      },
      {
        media: '零售观察',
        title: '限购与补货，品牌如何平衡热度与体验',
        angle: '从门店运营角度讨论补货方案',
        time: '09-10 10:30',
      },
      {
        media: '媒介观察',
        title: '排队画面本身也是一种传播素材',
        angle: '分析排队画面的传播属性',
        time: '09-10 14:00',
      },
    ],
  },
  {
    slug: 'phone-flagship-debut',
    title: '旗舰新机发布：影像样张成为对比焦点',
    category: '科技',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20minimal%20tech%20product%20scene%20with%20warm%20amber%20gradient%20light%20and%20soft%20geometric%20shapes%2C%20editorial%20illustration%2C%20cream%20background%2C%20no%20text&width=1200&height=800&seq=topic-cover-phone-06&orientation=landscape',
    summary:
      '发布会重点介绍影像与续航能力，会后数码博主陆续放出实拍样张，讨论集中在夜景解析力与色彩倾向的取舍上，预售数据随后公布。',
    heat: 6320,
    followers: '1.8万',
    updateCount: 4,
    startedAt: '09-09 19:30',
    status: '持续发酵',
    timeline: [
      {
        time: '09-09 19:30',
        title: '新品发布会举行',
        desc: '发布会重点介绍影像系统与续航表现，公布各配色与版本价格。',
        source: '官方发布会',
        tag: '事件起点',
      },
      {
        time: '09-09 21:03',
        title: '实拍样张陆续释出',
        desc: '多位数码博主发布夜景与逆光样张，解析力与色彩倾向成为讨论重点。',
        source: '数码博主',
        tag: '扩散',
      },
      {
        time: '09-09 11:37',
        title: '预售页面开放',
        desc: '官方开放预售通道并公布各配色首批备货比例，主打配色部分渠道显示售罄。',
        source: '官方商城',
        tag: '数据',
      },
      {
        time: '09-10 09:00',
        title: '首批评测汇总发布',
        desc: '多家媒体发布综合评测，对影像与续航给出不同侧重，评价整体偏正面。',
        source: '多家媒体',
        tag: '媒体报道',
      },
    ],
    reports: [
      {
        media: '数码头条',
        title: '影像升级之后，这一次的取舍在哪',
        angle: '从样张对比分析影像策略',
        time: '09-10 09:00',
      },
      {
        media: '科技新视野',
        title: '续航实测：一天重度使用够不够',
        angle: '以实测数据讨论续航表现',
        time: '09-10 11:20',
      },
      {
        media: '消费前线',
        title: '预售备货比例透露了什么',
        angle: '从备货结构推测主推方向',
        time: '09-10 15:40',
      },
    ],
  },
  {
    slug: 'city-night-market',
    title: '城市夜市排队风波：管理方公布分流方案',
    category: '网络',
    cover:
      'https://readdy.ai/api/search-image?query=abstract%20warm%20night%20market%20scene%20with%20amber%20string%20lights%20and%20soft%20bokeh%2C%20editorial%20illustration%2C%20cream%20and%20terracotta%20tones%2C%20no%20text&width=1200&height=800&seq=topic-cover-market-07&orientation=landscape',
    summary:
      '周末夜市因排队时段过长引发讨论，管理方先回应问题，随后公布入场分流与限流方案，并将试行时间定在本周五。',
    heat: 5110,
    followers: '1.1万',
    updateCount: 3,
    startedAt: '09-08 18:40',
    status: '已平息',
    timeline: [
      {
        time: '09-08 18:40',
        title: '排队画面引发讨论',
        desc: '网友发布周末夜市入口排队画面，等待时间过长成为讨论焦点。',
        source: '社交平台',
        tag: '事件起点',
      },
      {
        time: '09-08 16:21',
        title: '管理方首次回应',
        desc: '管理方称将在入口增设引导岗位并优化动线，后续视效果调整。',
        source: '夜市管理方',
        tag: '回应',
      },
      {
        time: '09-09 19:41',
        title: '分流方案公布',
        desc: '管理方公布入场分流与限流方案，本周五起试行，并同步调整营业时段。',
        source: '夜市管理方',
        tag: '后续',
      },
    ],
    reports: [
      {
        media: '城事记录',
        title: '夜市排队难题，动线设计能解决多少',
        angle: '从动线设计角度讨论排队问题',
        time: '09-09 20:00',
      },
      {
        media: '城市文化周刊',
        title: '被流量选中的夜市，如何接住人流',
        angle: '讨论网红街区的人流承接能力',
        time: '09-10 09:30',
      },
      {
        media: '媒介观察',
        title: '限流之后，体验会更好吗',
        angle: '分析限流方案的执行难点',
        time: '09-10 16:20',
      },
    ],
  },
];